// utils/voiceConstants.js
// Single source of truth for all voice configurations

// List of available voices with their configuration
export const AVAILABLE_VOICES = {
  // Google voices
  /*
� 'en-US-Standard-H': { 
� � name: 'English (US) - Standard Female',
� � provider: 'Google',
� � voiceId: 'en-US-Standard-H',
� � languageCode: 'en-US'
� },
� */

  'en-US-Studio-O': {
    name: 'English (US) - Google Studio Voice',
    provider: 'Google',
    voiceId: 'en-US-Studio-O',
    languageCode: 'en-US'
  },

  'en-US-Chirp3-HD-Despina': {
    name: 'English (US) - Chirp3 HD Despina',
    provider: 'Google',
    voiceId: 'en-US-Chirp3-HD-Despina',
    languageCode: 'en-US'
  },

  'en-US-Chirp3-HD-Laomedeia': {
    name: 'English (US) - Chirp3 HD Laomedeia',
    provider: 'Google',
    voiceId: 'en-US-Chirp3-HD-Laomedeia',
    languageCode: 'en-US'
  },

  'en-US-Gemini-Despina': {
    name: 'English (US) - Gemini Despina Flash ⭐',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'en-US',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'en-US-Gemini-Despina-Pro': {
    name: 'English (US) - Gemini Despina Pro ',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'en-US',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'en-US-Gemini-Aoede': {
    name: 'English (US) - Gemini Aoede Flash ⭐',
    provider: 'Gemini',
    voiceId: 'Aoede',
    languageCode: 'en-US',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'en-US-Gemini-Aoede-Pro': {
    name: 'English (US) - Gemini Aoede Pro 💎',
    provider: 'Gemini',
    voiceId: 'Aoede',
    languageCode: 'en-US',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'en-US-Gemini-Aoede-Preview': {
    name: 'English (US) - Gemini Aoede Preview ',
    provider: 'Gemini',
    voiceId: 'Aoede',
    languageCode: 'en-US',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'en-US-Gemini-Aoede-SimpleTTS': {
    name: 'AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'en-US',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'en-US-Gemini-Erinome-SimpleTTS': {
    name: 'ERINOME for Cityrama - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Erinome',
    languageCode: 'en-US',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'en-US-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'en-US',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'en-US-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'English (US) - AOEDE SimpleTTS - Gemini 2.5 Pro TTS ??',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'en-US',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'en-US-Gemini-Despina-SimpleTTS': {
    name: 'English (US) - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) ??',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'en-US',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'  // Pro model for highest quality
  },

  'en-US-Neural2-J': {
    name: 'English (US) - Neural2-J ? Multilingual',
    provider: 'Google',
    voiceId: 'en-US-Neural2-J',
    languageCode: 'en-US'
  },

  'en-US-Standard-D': {
    name: 'English (US) - Standard-D ? Multilingual',
    provider: 'Google',
    voiceId: 'en-US-Standard-D',
    languageCode: 'en-US'
  },

  // Azure voices - structured with explicit Azure-specific parameters
  'pt-PT-RaquelNeural': { // Updated key to match voice name
    name: 'Portuguese (PT) - Raquel Neural',
    provider: 'Azure',
    language: 'Portuguese',
    voiceId: 'pt-PT-RaquelNeural', // Native Portuguese Azure voice
    azureVoiceName: 'pt-PT-RaquelNeural', // Explicit Azure voice name
    azureLanguage: 'pt-PT', // Explicit Azure language code
    languageCode: 'pt-PT',
    speakingRate: 0.9
  },

  'en-US-AvaMultilingualNeural-pt-PT': {
    name: 'Portuguese (PT) - Ava Multilingual',
    provider: 'Azure',
    language: 'Portuguese',
    voiceId: 'en-US-AvaMultilingualNeural', // Ava Multilingual Azure voice
    azureVoiceName: 'en-US-AvaMultilingualNeural', // Explicit Azure voice name
    azureLanguage: 'pt-PT', // Explicit Azure language code
    languageCode: 'pt-PT',
    speakingRate: 0.9
  },

  'pt-PT-Gemini-Despina': {
    name: 'Portuguese (PT) - Gemini Despina Flash ?',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'pt-PT-Gemini-Despina-Pro': {
    name: 'Portuguese (PT) - Gemini Despina Pro ??',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'pt-PT-Gemini-Aoede': {
    name: 'Portuguese (PT) - Gemini Aoede Flash ?',
    provider: 'Gemini',
    voiceId: 'Aoede',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'pt-PT-Gemini-Aoede-Pro': {
    name: 'Portuguese (PT) - Gemini Aoede Pro ??',
    provider: 'Gemini',
    voiceId: 'Aoede',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'pt-PT-Gemini-Aoede-Preview': {
    name: 'Portuguese (PT) - Gemini Aoede Preview 🚀',
    provider: 'Gemini',
    voiceId: 'Aoede',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'pt-PT-Gemini-Aoede-SimpleTTS': {
    name: 'PT - AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'pt-PT-Gemini-Erinome-SimpleTTS': {
    name: 'PT - ERINOME for Cityrama - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Erinome',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'pt-PT-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'PT - AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'pt-PT-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'Portugal Portuguese - AOEDE SimpleTTS - Gemini 2.5 Pro TTS ??',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'pt-PT-Gemini-Despina-SimpleTTS': {
    name: 'Portuguese (PT) - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) ??',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'pt-BR-Gemini-Aoede-SimpleTTS': {
    name: 'BR - AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'pt-BR-Gemini-Erinome-SimpleTTS': {
    name: 'BR - ERINOME for Cityrama - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Erinome',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'pt-BR-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'BR - AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'pt-BR-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'Brazil Portuguese - AOEDE SimpleTTS - Gemini 2.5 Pro TTS ??',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'pt-BR-Gemini-Despina-SimpleTTS': {
    name: 'Portuguese (BR) - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) ??',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'pt-BR-Gemini-Despina-Pro-Legacy': {
    name: 'Portuguese (BR) - Gemini Despina Pro ??',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  /*
  // Dragon HD voices for different languages - each with a unique key
  'pt-PT-Dragon': { 
    name: 'PT - Ava Dragon HD latest Multilingual',
    provider: 'Azure',
    language: 'PT',
    azureVoiceName: 'en-US-Ava:DragonHDLatestNeural', // Explicit Azure voice name
    azureLanguage: 'pt-PT', // Explicit Azure language code
    languageCode: 'pt-PT'
  },
  /*

  */

  // Azure voices - structured with explicit Azure-specific parameters
  'en-US-AvaMultilingualNeural-pt-BR': { // Renamed key
    name: 'Portuguese (BR) -  Amazon Ava Multilingual',
    provider: 'Azure',
    language: 'BR',
    voiceId: 'en-US-AvaMultilingualNeural', // Actual Azure voice name for backend
    azureVoiceName: 'en-US-AvaMultilingualNeural', // Explicit Azure voice name
    azureLanguage: 'pt-BR', // Explicit Azure language code
    languageCode: 'pt-BR'
  },

  'pt-BR-Chirp3-HD-Despina': {
    name: 'Portuguese (BR) - Chirp3 HD',
    provider: 'Google',
    voiceId: 'pt-BR-Chirp3-HD-Despina',
    languageCode: 'pt-BR'
  },

  'pt-BR-Gemini-Despina': {
    name: 'Portuguese (BR) - Gemini Despina Flash ',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'pt-BR-Gemini-Despina-Pro': {
    name: 'Portuguese (BR) - Gemini Despina Pro',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'de-DE-Studio-C': {
    name: 'German (DE) -  Google Studio Voice',
    provider: 'Google',
    voiceId: 'de-DE-Studio-C',
    languageCode: 'de-DE'
  },

  'de-DE-Chirp3-HD-Despina': {
    name: 'German (DE) - Chirp3 HD',
    provider: 'Google',
    voiceId: 'de-DE-Chirp3-HD-Despina',
    languageCode: 'de-DE'
  },

  'de-DE-Gemini-Despina': {
    name: 'German (DE) - Gemini Despina Flash',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'de-DE',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'de-DE-Gemini-Despina-Pro': {
    name: 'German (DE) - Gemini Despina Pro ??',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'de-DE',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'de-DE-Gemini-Aoede-SimpleTTS': {
    name: 'DE - AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'de-DE',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'de-DE-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'DE - AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'de-DE',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'de-DE-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'German - AOEDE SimpleTTS - Gemini 2.5 Pro TTS ??',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'de-DE',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'de-DE-Gemini-Despina-SimpleTTS': {
    name: 'German (DE) - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) ??',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'de-DE',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'es-ES-Studio-C': {
    name: 'Spanish (ES) -  Google Studio Voice',
    provider: 'Google',
    voiceId: 'es-ES-Studio-C',
    languageCode: 'es-ES'
  },

  'es-ES-Chirp3-HD-Despina': {
    name: 'Spanish (ES) - Chirp3 HD',
    provider: 'Google',
    voiceId: 'es-ES-Chirp3-HD-Despina',
    languageCode: 'es-ES'
  },

  'es-ES-Gemini-Despina': {
    name: 'Spanish (ES) - Gemini Despina Flash ?',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'es-ES',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'es-ES-Gemini-Despina-Pro': {
    name: 'Spanish (ES) - Gemini Despina Pro ??',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'es-ES',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'es-ES-Gemini-Aoede-SimpleTTS': {
    name: 'ES - AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'es-ES',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'es-ES-Gemini-Erinome-SimpleTTS': {
    name: 'ES - ERINOME for Cityrama - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Erinome',
    languageCode: 'es-ES',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'es-ES-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'ES - AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'es-ES',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'es-ES-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'Spanish - AOEDE SimpleTTS - Gemini 2.5 Pro TTS ??',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'es-ES',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'es-ES-Gemini-Despina-SimpleTTS': {
    name: 'Spanish (ES) - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) ??',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'es-ES',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'fr-FR-Studio-A': {
    name: 'French (FR) - Google Studio Voice',
    provider: 'Google',
    voiceId: 'fr-FR-Studio-A',
    languageCode: 'fr-FR'
  },

  'fr-FR-Chirp3-HD-Despina': {
    name: 'French (FR) - Chirp3 HD',
    provider: 'Google',
    voiceId: 'fr-FR-Chirp3-HD-Despina',
    languageCode: 'fr-FR'
  },

  'fr-FR-Gemini-Despina': {
    name: 'French (FR) - Gemini Despina Flash ⭐',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'fr-FR',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'fr-FR-Gemini-Despina-Pro': {
    name: 'French (FR) - Gemini Despina Pro 💎',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'fr-FR',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'fr-FR-Gemini-Aoede-SimpleTTS': {
    name: 'FR - AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'fr-FR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'fr-FR-Gemini-Erinome-SimpleTTS': {
    name: 'FR - ERINOME for Cityrama - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Erinome',
    languageCode: 'fr-FR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'fr-FR-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'FR - AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'fr-FR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'fr-FR-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'French - AOEDE SimpleTTS - Gemini 2.5 Pro TTS 💎',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'fr-FR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'fr-FR-Gemini-Despina-SimpleTTS': {
    name: 'French (FR) - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) 🎵',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'fr-FR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  // Azure voices - structured with explicit Azure-specific parameters
  'fr-FR-AvaMultilingual': { // Renamed key
    name: 'French (FR) -  Amazon Ava Multilingual',
    provider: 'Azure',
    language: 'FR',
    voiceId: 'en-US-AvaMultilingualNeural', // Actual Azure voice name for backend
    azureVoiceName: 'en-US-AvaMultilingualNeural', // Explicit Azure voice name
    azureLanguage: 'fr-FR', // Explicit Azure language code
    languageCode: 'fr-FR'
  },

  // Azure voices - structured with explicit Azure-specific parameters
  'de-DE-AvaMultilingual': { // Renamed key
    name: 'German (DE) - Amazon Ava Multilingual',
    provider: 'Azure',
    language: 'DE',
    voiceId: 'en-US-AvaMultilingualNeural', // Actual Azure voice name for backend
    azureVoiceName: 'en-US-AvaMultilingualNeural', // Explicit Azure voice name
    azureLanguage: 'de-DE', // Explicit Azure language code
    languageCode: 'de-DE'
  },

  // Azure voices - structured with explicit Azure-specific parameters
  'es-ES-AvaMultilingual': { // Renamed key
    name: 'Spanish (ES) - Amazon Ava Multilingual',
    provider: 'Azure',
    language: 'ES',
    voiceId: 'en-US-AvaMultilingualNeural', // Actual Azure voice name for backend
    azureVoiceName: 'en-US-AvaMultilingualNeural', // Explicit Azure voice name
    azureLanguage: 'es-ES', // Explicit Azure language code
    languageCode: 'es-ES'
  },


  // Add Bulgarian version with Dragon HD
  'bg-BG-KalinaNeural': {
    name: 'BG - Kalina Neural - Azure',
    provider: 'Azure',
    language: 'BG',
    voiceId: 'bg-BG-KalinaNeural', // Required for backend
    azureVoiceName: 'bg-BG-KalinaNeural', // Same Azure voice name
    azureLanguage: 'bg-BG', // Different language code
    languageCode: 'bg-BG'
  },

  'bg-BG-Gemini-Despina': {
    name: 'Bulgarian - Gemini Despina Flash ⭐',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'bg-BG',
    useGeminiTts: true,
    model: 'gemini-2.5-flash-tts'
  },

  'bg-BG-Gemini-Despina-Pro': {
    name: 'Bulgarian - Gemini Despina Pro 💎',
    provider: 'Gemini',
    voiceId: 'Despina',
    languageCode: 'bg-BG',
    useGeminiTts: true,
    model: 'gemini-2.5-pro-tts'
  },

  'bg-BG-Gemini-Aoede-SimpleTTS': {
    name: 'BG - AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'bg-BG',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'bg-BG-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'BG - AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'bg-BG',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'bg-BG-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'Bulgarian - AOEDE SimpleTTS - Gemini 2.5 Pro TTS 💎',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'bg-BG',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'bg-BG-Gemini-Despina-SimpleTTS': {
    name: 'Bulgarian - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) 🎵',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'bg-BG',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'ar-XA-Chirp3-HD-Aoede': {
    name: 'Arabic - Chirp3 HD Aoede',
    provider: 'Google',
    voiceId: 'ar-XA-Chirp3-HD-Aoede',
    languageCode: 'ar-XA'
  },

  'ar-XA-Gemini-Aoede-SimpleTTS': {
    name: 'AR - AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'ar-XA',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'ar-XA-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'AR - AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'ar-XA',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'ar-XA-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'Arabic - AOEDE SimpleTTS - Gemini 2.5 Pro TTS 💎',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'ar-XA',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'ar-XA-Gemini-Despina-SimpleTTS': {
    name: 'Arabic - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) 🎵',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'ar-XA',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'it-IT-Chirp3-HD-Aoede': {
    name: 'Italian - Chirp3 HD Aoede',
    provider: 'Google',
    voiceId: 'it-IT-Chirp3-HD-Aoede',
    languageCode: 'it-IT'
  },

  'it-IT-Gemini-Aoede-SimpleTTS': {
    name: 'IT - AOEDE SimpleTTS - Gemini 3.1 Flash TTS Preview',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'it-IT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.1-flash-tts-preview'
  },

  'it-IT-Gemini-Aoede-SimpleTTS-Legacy': {
    name: 'IT - AOEDE SimpleTTS - Gemini 2.5 Pro Preview TTS',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'it-IT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  'it-IT-Gemini-Aoede-SimpleTTS-Pro': {
    name: 'Italian - AOEDE SimpleTTS - Gemini 2.5 Pro TTS 💎',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'it-IT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-tts'
  },

  'it-IT-Gemini-Despina-SimpleTTS': {
    name: 'Italian - Despina SimpleTTS - Gemini 2.5 Pro Preview TTS (Highest Quality) 🎵',
    provider: 'Google',
    voiceId: 'Despina',
    languageCode: 'it-IT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-2.5-pro-preview-tts'
  },

  // Gemini 3.8 Flash TTS - stable on long-form audio, so these default to much larger chunks
  'en-US-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'en-US',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  },

  'pt-PT-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 PT - AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'pt-PT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  },

  'pt-BR-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 BR - AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'pt-BR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  },

  'es-ES-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 ES - AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'es-ES',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  },

  'fr-FR-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 FR - AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'fr-FR',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  },

  'de-DE-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 DE - AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'de-DE',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  },

  'bg-BG-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 BG - AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'bg-BG',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  },

  'ar-XA-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 AR - AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'ar-XA',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  },

  'it-IT-Gemini-Aoede-SimpleTTS-38': {
    name: '🟢 IT - AOEDE SimpleTTS - Gemini 3.8 Flash TTS (Default) 🟢',
    provider: 'Google',
    voiceId: 'Aoede',
    languageCode: 'it-IT',
    useGeminiTts: true,
    useSimpleTtsMethod: true,
    model: 'gemini-3.8-flash-tts'
  }

  // Add more voices as needed
};

const LANGUAGE_TO_DEFAULT_VOICE_ID = {
  en: 'en-US-Gemini-Aoede-SimpleTTS-38',
  'en-us': 'en-US-Gemini-Aoede-SimpleTTS-38',
  pt: 'pt-PT-Gemini-Aoede-SimpleTTS-38',
  'pt-pt': 'pt-PT-Gemini-Aoede-SimpleTTS-38',
  'pt-br': 'pt-BR-Gemini-Aoede-SimpleTTS-38',
  es: 'es-ES-Gemini-Aoede-SimpleTTS-38',
  'es-es': 'es-ES-Gemini-Aoede-SimpleTTS-38',
  fr: 'fr-FR-Gemini-Aoede-SimpleTTS-38',
  'fr-fr': 'fr-FR-Gemini-Aoede-SimpleTTS-38',
  de: 'de-DE-Gemini-Aoede-SimpleTTS-38',
  'de-de': 'de-DE-Gemini-Aoede-SimpleTTS-38',
  bg: 'bg-BG-Gemini-Aoede-SimpleTTS-38',
  'bg-bg': 'bg-BG-Gemini-Aoede-SimpleTTS-38',
  it: 'it-IT-Gemini-Aoede-SimpleTTS-38',
  'it-it': 'it-IT-Gemini-Aoede-SimpleTTS-38',
  ar: 'ar-XA-Gemini-Aoede-SimpleTTS-38',
  'ar-xa': 'ar-XA-Gemini-Aoede-SimpleTTS-38',
  nl: 'nl-NL-Wavenet-B',
  'nl-nl': 'nl-NL-Wavenet-B',
  ru: 'ru-RU-Wavenet-A',
  'ru-ru': 'ru-RU-Wavenet-A'
};

export const getDefaultVoiceForLanguage = (contentLanguage) => {
  if (!contentLanguage) {
    return LANGUAGE_TO_DEFAULT_VOICE_ID.en;
  }

  const normalized = String(contentLanguage).trim().toLowerCase().replace('_', '-');
  if (LANGUAGE_TO_DEFAULT_VOICE_ID[normalized]) {
    return LANGUAGE_TO_DEFAULT_VOICE_ID[normalized];
  }

  const prefix = normalized.split('-')[0];
  return LANGUAGE_TO_DEFAULT_VOICE_ID[prefix] || LANGUAGE_TO_DEFAULT_VOICE_ID.en;
};

// Group voices by language for UI organization
export const VOICE_GROUPS = [{
    language: 'English',
    voices: ['en-US-Gemini-Aoede-SimpleTTS-38', 'en-US-Gemini-Aoede-SimpleTTS', 'en-US-Gemini-Erinome-SimpleTTS', 'en-US-Gemini-Aoede-SimpleTTS-Legacy', 'en-US-Gemini-Aoede-SimpleTTS-Pro', 'en-US-Gemini-Despina-SimpleTTS', 'en-US-Gemini-Despina', 'en-US-Gemini-Despina-Pro', 'en-US-Gemini-Aoede', 'en-US-Gemini-Aoede-Pro', 'en-US-Gemini-Aoede-Preview', 'en-US-Neural2-J', 'en-US-Standard-F', 'en-US-Studio-O', 'en-US-Chirp3-HD-Despina', 'en-US-Chirp3-HD-Laomedeia']
  },
  {
    language: 'Portugal Portuguese ',
    voices: ['pt-PT-Gemini-Aoede-SimpleTTS-38', 'pt-PT-Gemini-Aoede-SimpleTTS', 'pt-PT-Gemini-Erinome-SimpleTTS', 'pt-PT-Gemini-Aoede-SimpleTTS-Legacy', 'pt-PT-Gemini-Aoede-SimpleTTS-Pro', 'pt-PT-Gemini-Despina-SimpleTTS', 'pt-PT-Gemini-Despina', 'pt-PT-Gemini-Despina-Pro', 'pt-PT-Gemini-Aoede', 'pt-PT-Gemini-Aoede-Pro', 'pt-PT-Gemini-Aoede-Preview', 'pt-PT-RaquelNeural', 'en-US-AvaMultilingualNeural-pt-PT'] // Gemini first
  },
  {
    language: 'Brazil Portuguese ',
    voices: ['pt-BR-Gemini-Aoede-SimpleTTS-38', 'pt-BR-Gemini-Aoede-SimpleTTS', 'pt-BR-Gemini-Erinome-SimpleTTS', 'pt-BR-Gemini-Aoede-SimpleTTS-Legacy', 'pt-BR-Gemini-Aoede-SimpleTTS-Pro', 'pt-BR-Gemini-Despina-SimpleTTS', 'pt-BR-Gemini-Despina', 'pt-BR-Gemini-Despina-Pro', 'pt-BR-Chirp3-HD-Despina', 'en-US-AvaMultilingualNeural-pt-BR'] // SimpleTTS first
  },
  {
    language: 'Spanish ',
    voices: ['es-ES-Gemini-Aoede-SimpleTTS-38', 'es-ES-Gemini-Aoede-SimpleTTS', 'es-ES-Gemini-Erinome-SimpleTTS', 'es-ES-Gemini-Aoede-SimpleTTS-Legacy', 'es-ES-Gemini-Aoede-SimpleTTS-Pro', 'es-ES-Gemini-Despina-SimpleTTS', 'es-ES-Gemini-Despina', 'es-ES-Gemini-Despina-Pro', 'es-ES-Chirp3-HD-Despina', 'es-ES-Studio-C', 'es-ES-AvaMultilingual'] // SimpleTTS first
  },
  {
    language: 'German ',
    voices: ['de-DE-Gemini-Aoede-SimpleTTS-38', 'de-DE-Gemini-Aoede-SimpleTTS', 'de-DE-Gemini-Aoede-SimpleTTS-Legacy', 'de-DE-Gemini-Aoede-SimpleTTS-Pro', 'de-DE-Gemini-Despina-SimpleTTS', 'de-DE-Gemini-Despina', 'de-DE-Gemini-Despina-Pro', 'de-DE-Chirp3-HD-Despina', 'de-DE-Studio-C', 'de-DE-AvaMultilingual'] // SimpleTTS first
  },
  {
    language: 'French',
    voices: ['fr-FR-Gemini-Aoede-SimpleTTS-38', 'fr-FR-Gemini-Aoede-SimpleTTS', 'fr-FR-Gemini-Erinome-SimpleTTS', 'fr-FR-Gemini-Aoede-SimpleTTS-Legacy', 'fr-FR-Gemini-Aoede-SimpleTTS-Pro', 'fr-FR-Gemini-Despina-SimpleTTS', 'fr-FR-Gemini-Despina', 'fr-FR-Gemini-Despina-Pro', 'fr-FR-Chirp3-HD-Despina', 'fr-FR-Studio-A', 'fr-FR-AvaMultilingual'] // SimpleTTS first
  },
  /*
  {
    language: 'Brazil Portuguese',
    voices: [  'pt-BR-AvaMultilingual',  'pt-PT-Dragon',  'en-US-AvaMultilingualNeural', 'pt-BR-Dragon']
  },
   
  {  language: 'Spanish',
    voices: ['es-ES-AvaMultilingual', 'es-ES-Dragon']
  },
  */
  {
    language: 'Bulgarian',
    voices: ['bg-BG-Gemini-Aoede-SimpleTTS-38', 'bg-BG-Gemini-Aoede-SimpleTTS', 'bg-BG-Gemini-Aoede-SimpleTTS-Legacy', 'bg-BG-Gemini-Aoede-SimpleTTS-Pro', 'bg-BG-Gemini-Despina-SimpleTTS', 'bg-BG-Gemini-Despina', 'bg-BG-Gemini-Despina-Pro', 'bg-BG-KalinaNeural', /*'bg-BG-AvaMultilingual', 'bg-BG-Dragon', */ ] // SimpleTTS first
  },
  {
    language: 'Arabic',
    voices: ['ar-XA-Gemini-Aoede-SimpleTTS-38', 'ar-XA-Gemini-Aoede-SimpleTTS', 'ar-XA-Gemini-Aoede-SimpleTTS-Legacy', 'ar-XA-Gemini-Aoede-SimpleTTS-Pro', 'ar-XA-Gemini-Despina-SimpleTTS', 'ar-XA-Chirp3-HD-Aoede']
  },
  {
    language: 'Italian',
    voices: ['it-IT-Gemini-Aoede-SimpleTTS-38', 'it-IT-Gemini-Aoede-SimpleTTS', 'it-IT-Gemini-Aoede-SimpleTTS-Legacy', 'it-IT-Gemini-Aoede-SimpleTTS-Pro', 'it-IT-Gemini-Despina-SimpleTTS', 'it-IT-Chirp3-HD-Aoede']
  }
];

// Helper function to find a voice that matches the content language
export const findVoiceForLanguage = (contentLanguage) => {
  if (!contentLanguage) return LANGUAGE_TO_DEFAULT_VOICE_ID.en;

  const lowerContentLanguage = String(contentLanguage).trim().toLowerCase().replace('_', '-');
  const defaultVoice = getDefaultVoiceForLanguage(lowerContentLanguage);

  if (AVAILABLE_VOICES[defaultVoice]) {
    return defaultVoice;
  }

  // Priority 0: Try to find SimpleTTS Aoede voice for the language first
  const simpleTtsAoedeKey = Object.keys(AVAILABLE_VOICES).find(voiceId => {
    const voice = AVAILABLE_VOICES[voiceId];
    return voice.useSimpleTtsMethod === true &&
           voice.voiceId === 'Aoede' &&
           voice.languageCode &&
           voice.languageCode.toLowerCase() === lowerContentLanguage;
  });

  if (simpleTtsAoedeKey) return simpleTtsAoedeKey;

  // Priority 1: Try to find any SimpleTTS voice for the language
  const simpleTtsKey = Object.keys(AVAILABLE_VOICES).find(voiceId => {
    const voice = AVAILABLE_VOICES[voiceId];
    return voice.useSimpleTtsMethod === true &&
           voice.languageCode &&
           voice.languageCode.toLowerCase() === lowerContentLanguage;
  });

  if (simpleTtsKey) return simpleTtsKey;

  // Priority 2: Try to find Gemini Aoede voice for the language
  const geminiAoedeKey = Object.keys(AVAILABLE_VOICES).find(voiceId => {
    const voice = AVAILABLE_VOICES[voiceId];
    return voice.provider === 'Gemini' &&
           voice.voiceId === 'Aoede' &&
           voice.model === 'gemini-2.5-flash-tts' &&
           voice.languageCode &&
           voice.languageCode.toLowerCase() === lowerContentLanguage;
  });

  if (geminiAoedeKey) return geminiAoedeKey;

  // Priority 1: Try to find any Gemini voice for the language
  const geminiVoiceKey = Object.keys(AVAILABLE_VOICES).find(voiceId => {
    const voice = AVAILABLE_VOICES[voiceId];
    return voice.provider === 'Gemini' &&
           voice.languageCode &&
           voice.languageCode.toLowerCase() === lowerContentLanguage;
  });

  if (geminiVoiceKey) return geminiVoiceKey;

  // Priority 1: Specific override for pt-PT to ensure it always uses the designated voice
  if (lowerContentLanguage === 'pt-pt') {
    const ptPTVoiceKey = 'pt-PT-RaquelNeural';
    // Check if this specific voice is configured and is indeed a pt-PT voice
    if (AVAILABLE_VOICES[ptPTVoiceKey] && AVAILABLE_VOICES[ptPTVoiceKey].languageCode.toLowerCase() === 'pt-pt') {
      return ptPTVoiceKey;
    }
  }

  // Priority 2: Find a voice where its 'languageCode' exactly matches the 'contentLanguage'
  // (e.g., contentLanguage 'de-DE' matches voice with languageCode 'de-DE')
  let bestMatch = Object.keys(AVAILABLE_VOICES).find(voiceId => {
    const voice = AVAILABLE_VOICES[voiceId];
    return voice.languageCode && voice.languageCode.toLowerCase() === lowerContentLanguage;
  });

  if (bestMatch) return bestMatch;

  // Priority 3: Find a voice where its 'languageCode' starts with the two-letter prefix of 'contentLanguage'
  // (e.g., contentLanguage 'pt-BR' could match a voice with languageCode 'pt-PT' if no exact 'pt-BR' voice is found)
  const langPrefix = lowerContentLanguage.substring(0, 2);
  bestMatch = Object.keys(AVAILABLE_VOICES).find(voiceId => {
    const voice = AVAILABLE_VOICES[voiceId];
    return voice.languageCode && voice.languageCode.toLowerCase().startsWith(langPrefix);
  });

  if (bestMatch) return bestMatch;

  // Priority 4: Fallback to original logic - match based on voiceId key prefix (less reliable)
  // This is kept for backward compatibility or if languageCode is missing in some voice definitions.
  const keyBasedMatch = Object.keys(AVAILABLE_VOICES).find(voiceId =>
    voiceId.toLowerCase().startsWith(langPrefix + '-') // e.g. 'en-' for 'en-US'
  );

  if (keyBasedMatch) return keyBasedMatch;

  // Default: If no suitable voice is found, return a general default voice
  return defaultVoice;
};
